export const en = {
  ui: {
    hub_title: "My Accreditation Reports",
    hub_subtitle: "Access your certification status, formal audit reports, and feedback archive.",
    badge_header: "My Digital Badge",
    badge_desc: "Select your preferred badge style to copy the code to the clipboard. Send this code to your website manager to upload your badge.",
    badge_expiry_prefix: "Please note that the badge will automatically show 'IFIP Accreditation Pending' when your accreditation is due for renewal on",
    btn_yes: "Yes",
    btn_no: "No",
    btn_copy_code: "Copy Embed Code",
    msg_copied: "Your Embed Code has been copied to the clipboard!",
    msg_pending_badge: "When your report is published, your code to upload your digital badge to your website will be available here.",
    status_published_title: "Cycle Complete",
    status_published_desc: "Your formal report was issued on",
    status_factcheck_title: "Action Required: Fact-Check",
    status_factcheck_desc: "Please review the draft report below and provide accuracy feedback.",
    status_review_title: "Under IFIP Review",
    status_review_desc: "Your submission is currently being reviewed by the IFIP clinical team.",
    btn_download: "Download Certificate",
    btn_view: "View Final Report",
    workspace_title: "Fact-Check Workspace",
    workspace_desc: "Please review each station and provide specific feedback only if factual corrections are required.",
    btn_submit_feedback: "Submit Accuracy Feedback",
    btn_accept: "Accept Findings",
    header_archive: "Historical Archive",
    label_issued: "Issued",
    btn_view_archive: "View",
    msg_no_archive: "No historical reports on file.",
    label_current_status: "Current Status",
    header_draft_report: "Clinical Draft Report",
    label_exec_summary: "Portrait of {{schoolName}}",
    label_station: "Station",
    header_accuracy_feedback: "Accuracy Feedback",
    label_general_notes: "General Factual Notes",
    label_station_note: "Correction/Note",
    placeholder_general: "Provide overall accuracy notes here...",
    placeholder_station: "Notes regarding findings...",
    btn_report_translation: "Report translation error",
    t1_title: "My Registration Form",
    t1_desc: "Your registration form is locked, but you may still update key information in the School Profile panel",
    t1_status: "View / update",
    t2_title: "My Self-Evaluation Form",
    t2_desc: "Assess your institution against IFIP's 7-Station framework.",
    t2_desc_desktop_note: "Desktop/tablet only.",
    t2_status_submitted: "Submitted",
    t2_status_ready: "Ready to Submit",
    t2_status_drafting: "Drafting",
    t2_status_not_started: "Not Started",
    t3_title: "My Questionnaire",
    t3_desc: "Optional annual questionnaire to support IFIP's global research",
    t3_status_start: "Complete Optional Questionnaire",
    t3_status_update: "Update Due",
    t3_status_synced: "Synced",
    t4_title: "My Accreditation Reports",
    t4_desc: "Access your certification status, formal audit reports, and feedback archive.",
    t4_status_action: "Action: Please review your draft report",
    t4_status_view: "View reports",
    t5_title: "Renewals and upgrades",
    t5_desc: "Apply for a new accreditation cycle or a higher level — without repeating full registration.",
    t5_cta: "Apply",
    sef_choice_title: "Your previous self-evaluation",
    sef_choice_body: "The new cycle is open. Your issued report stays in My Reports. The previous scores, narratives, and evidence are saved either way.",
    sef_choice_keep: "Build on the previous self-evaluation",
    sef_choice_keep_hint: "The wording and evidence stay in the form so you can update them.",
    sef_choice_blank: "Start from a blank form",
    sef_choice_blank_hint: "The form is cleared. The previous version remains stored.",
    status_new_cycle_title: "New cycle open",
    status_new_cycle_desc: "Your previous report stays in Issued reports. Update your self-evaluation, then submit it when you are ready.",
    workflow_step_1: "Step 1: Select the Station (focus area)",
    workflow_step_2: "Step 2: Select your self-assessed maturity level",
    workflow_step_2_instruction: "Hover over a level to see the IFIP benchmarks. Pin the guide to keep it visible while you write your narrative in Step 3.",
    level_tooltip_pin: "Pin guide",
    level_tooltip_unpin: "Close",
    level_tooltip_pin_hint: "Pinned — stays open while you work elsewhere on this page",
    workflow_step_3: "Step 3: Write your supporting narrative",
    workflow_step_3_instruction: "Then repeat for the next Station (go back to Step 1). Your work will be saved automatically.",
    workflow_step_4: "Step 4: Upload your supporting evidence",
    workflow_step_5: "Step 5: Review & Submit",
    workflow_step_5_instruction: "Ready to submit? Press here to conduct an informal AI review first. You will still be able to edit before final submission.",
    btn_start_review: "Begin Final Review",
    portal_title: "IFIP Accreditation Portal",
    portal_subtitle: "Inclusion 2.0: The Global Excellence Framework",
    framework_version: "Inclusion 2.0",
    status_label: "Inclusion 2.0 Status:",
    status_draft: "Draft",
    status_submitted: "Submitted",
    status_cycle_complete: "Cycle complete",
    sync_indicator_prefix: "My application:",
    inactive_msg: "Your accreditation is not yet active. Please contact info@ifip.group for help.",
    sync_saving: "auto saving...",
    sync_saved: "Saved",
    sync_error: "Error",
    ok: "OK",
    sync_finalized: "Finalized",
    loading_msg: "Optimizing IFIP Workspace...",
    nav_station_prefix: "Station",
    btn_review_submit: "Review & Submit",
    btn_back_edit: "Back to Edit",
    btn_confirm_final: "Confirm and Submit Final Audit",
    btn_click_browse: "Click to Browse Files",
    review_header: "Final Audit Review",
    diagnostic_title: "Submission Diagnostic & Guidance",
    diagnostic_intro: "An automated scan of the submission has revealed the following:",
    diagnostic_complete_msg: "Diagnostic scan complete. Your progress is fully aligned with the IFIP Assessment Matrix.",
    review_station_title_suffix: "Maturity Level",
    review_no_narrative: "No Lived Experience narrative provided.",
    confirm_modal_alert: "Finalize audit? This will lock the submission for the IFIP Accreditation board.",
    label_maturity_selector: "Please select your self-assessed current maturity level:",
    label_level_prefix: "Level",
    label_narrative_input: "Lived Experience Narrative (The Qualitative Story):",
    placeholder_narrative: "Enter institutional narrative...",
    header_architecture_belonging: "Architecture of Belonging",
    dropzone_instruction: "Drag and drop evidence here.",
    evidence_hint: "Useful evidence might include budgets, policy documents, staff logs, photos, curriculum plans, etc.",
    alert_duplicate_file: "is already in the vault. Please use the 'Tag to' bar to link it to additional stations.",
    label_tag_to: "Tag to Stations",
    header_accepted_evidence: "Accepted Institutional Evidence",
    evidence_footer_note: "Note: Evidence uploaded here becomes part of the school's central repository. You can tag a document to multiple stations to avoid duplicates.",
    tab_guidance_open: "Handbook & Matrix",
    tab_guidance_close: "Close Guidance",
    tab_profile_open: "School Profile",
    tab_profile_close: "Close Profile",
    header_station_guidance: "Station Guidance:",
    header_assessment_matrix: "Assessment Matrix Points:",
    btn_enter_portal: "Enter Accreditation Portal",
    ai_disclaimer_title: "Important",
    btn_link: "Link",
    btn_unlink: "Unlink",
    btn_view: "View Evidence",
    btn_delete: "Remove File",
    submit_warning: "Once submitted, this assessment will be locked. You can view your responses, but no further changes can be made.",
    guide_translating: "Translating",
    /** Header row while portal / hub localization is in progress (also synced via app_main). */
    localizing_indicator: "Translating",

    /** Splash before `activeLang` is ready (rare). */
    portal_boot_loading_en: "LOADING...",
    portal_boot_loading_sync: "SYNCING DICTIONARY...",
    /** Evidence upload / vault (portal). Use {{maxMb}} and {{pct}} placeholders where noted. */
    alert_file_too_large: "File is too large. Maximum size is {{maxMb}} MB.",
    alert_photo_evidence_policy: "This looks like a photograph or image.\n\nIt will be stored securely in your evidence vault and viewed only by your assigned IFIP accreditor. Access is logged.\n\nPhotographs are never uploaded to AI systems.\n\nContinue with upload?",
    alert_profile_save_failed: "Failed to save. Please check your connection.",
    questionnaire_submission_error: "Submission error",
    sync_uploading: "Uploading...",
    sync_uploading_progress: "Uploading: {{pct}}%",
    sync_upload_error: "Upload error",
    sync_deleting: "Deleting...",
    sync_deleted: "Deleted",
    sync_delete_error: "Delete error",
    mobile_blocker_title: "Self-evaluation: desktop or large tablet",
    mobile_blocker_body:
      "The self-evaluation workspace (stations, matrix, and evidence vault) is designed for a wide screen. You can still use this device for the portal dashboard, questionnaire, and reports. To complete or review your self-evaluation, please switch to a computer or large tablet (about 1024px width or more).",

    /** Unified portal header toolbar (accessibility + language + translation mail). */
    portal_header_action_bar_aria: "Accessibility, language, and translation support",

    logo_upload_cta: "Click here to upload your school logo",
    logo_change_hint: "Change school logo",
    logo_alt: "School logo",
    logo_remove: "Remove",
    logo_remove_confirm: "Remove your school logo from the portal and public surfaces?",
    logo_crop_title: "Adjust your school logo",
    logo_crop_hint:
      "Drag to reposition and use the slider to zoom. Your logo is cropped to the same footprint as the IFIP logo (square frame, shown as a circle in the header).",
    logo_crop_zoom: "Zoom",
    logo_crop_cancel: "Cancel",
    logo_crop_save: "Save logo",
    logo_crop_drag_panel: "Drag here to move",
    logo_uploading: "Uploading school logo…",
    logo_saved: "School logo saved.",
    logo_removed: "School logo removed.",
    logo_error_too_large: "Image is too large (maximum 2 MB).",
    logo_error_load: "Could not load that image.",
    logo_error_upload: "Logo upload failed.",
    logo_error_remove: "Could not remove logo.",

    /** Colour-scheme accessibility (portal, registration, renewal; synced via app_main / chunks). */
    a11y_btn: "Accessibility",
    a11y_zoom_section_title: "Zoom",
    a11y_panel_aria_split: "Accessibility: zoom and colour scheme",
    a11y_panel_aria_split_register: "Accessibility: text size and colour scheme",
    a11y_font_scale_section: "Text size",
    a11y_font_scale_group: "Adjust registration page text size",
    a11y_font_scale_smaller: "Smaller text",
    a11y_font_scale_larger: "Larger text",
    a11y_panel_title: "Colour scheme",
    a11y_scheme_default: "Default theme",
    a11y_scheme_wb: "White text on black",
    a11y_scheme_cg: "Black text on white",
    a11y_scheme_nb: "Navy on pale blue",
    a11y_scheme_sol: "Teal on cream",
    a11y_hover_zoom_others_label: "Hover zoom on other controls",
    a11y_hover_zoom_others_hint:
      "When this is on, the language selector, report links, dashboard tiles, header buttons, and side drawer tabs use the same large hover zoom as the status badges.",
    img_alt_ifip: "IFIP",
    img_alt_ifip_globe: "IFIP globe mark",

    // Integrated AI Interface Block (G95-G96)
    ai_header: "IFIP AI Diagnostic Analysis",
    ai_analyzing: "Analyzing your narrative against the IFIP Matrix...",
    ai_analyzing_submission: "IFIP is currently analysing your submission",
    ai_result_ready: "Analysis Complete",
    ai_disclaimer_short: "This analysis is AI-generated based on the IFIP Excellence Framework.",
    ai_disclaimer_long: "Disclaimer: This is an AI-generated response provided to assist in your self-assessment process and serves as a preparatory tool; it is not a substitute for the formal IFIP consultant review that will occur upon your final submission.",

    grid_labels: {
      system: "System",
      financials: "Financials",
      personnel: "Personnel",
      tech: "Technology",
      pedagogy: "Pedagogy",
      studentRole: "Student Role",
      taRole: "TA Role",
      values: "Values",
      studentVoice: "Student Voice",
      community: "Community",
      sensory: "Sensory",
      agility: "Agility",
      format: "Format",
      language: "Language",
      authorship: "Authorship",
      vision: "Vision",
      accountability: "Accountability",
      board: "The Board",
      belief: "Belief",
      bias: "Bias",
      livedExperience: "Lived Experience"
    },

    auth_login: "Log In",
    auth_logout: "Log Out",
    auth_create_account: "Create Account",
    auth_forgot_password: "Forgot Password?",
    auth_reset_password: "Reset Password",
    field_email: "Email Address",
    field_password: "Password",
    nav_profile: "Institutional Profile",
    nav_welcome: "Welcome",
    nav_lang_select: "Language Selection",
    nav_dashboard: "Home / Dashboard",
    nav_my_audits: "My Audits",
    nav_start_new: "Start New Audit",
    action_download_pdf: "Download PDF",
    action_print: "Print Summary",
    nav_settings: "Settings",
    support_contact: "Contact IFIP",
    support_consultant: "Talk to Consultant",
    support_report_issue: "Report Issue",
    support_faq: "FAQ",
    support_handbook: "Digital Handbook",
    support_docs: "Help Docs",
    legal_privacy: "Privacy Policy",
    legal_terms: "Terms of Service",
    legal_gdpr: "GDPR Compliance",
    legal_cookies: "Cookie Preferences",
    alert_unsaved_exit: "Unsaved changes?",
    alert_session_expiring: "Session Expiring",
    alert_connection_lost: "Connection Lost",
    alert_save_success: "Saved Successfully",
    alert_submission_locked: "Submission Locked"
  },
  stations: [
    {
      id: "01",
      title: "Station 1: Resources",
      navTitle: "Resources",
      shortDefinition: "The strategic deployment of financial, human, and digital capital to ensure equitable access.",
      fullDescription: "Funding and financial resources are critical to ensure equitable access to services, support, and opportunities for all. This station addresses the importance of assigning adequate funding to support inclusion initiatives. Besides finances, resources may also include training programs, using volunteers and accessing local social initiatives.",
      mainReflectionQuestion: "Are resources thoughtfully allocated to the growth of inclusion?",
      assessmentMatrix: [
        { id: "budget_allocation", label: "Budgets for inclusion are distributed across the organisation", description: "How financial resources are distributed within your organisation to ensure equitable access." },
        { id: "staff_training", label: "Staff training for inclusion", description: "Investment of money and time in professional development for staff on inclusion practices." },
        { id: "monitoring_equity", label: "Monitoring equity of resource use", description: "Systems to track how funds are used, their impact on inclusion and ensuring that marginalized groups have access to the resources." },
        { id: "wellbeing_resources", label: "Resources support the development of 'belonging'", description: "Allocation of resources specifically to supporting the well-being and belonging for all." },
        { id: "accessibility_resources", label: "Resources support accessibility", description: "Meeting the broad needs of accessibility and communication and digital literacy for all." },
        { id: "digital_literacy", label: "Resources support digital literacy", description: "Specific focus on ensuring digital tools are safe, equitable, and accessible for everyone." },
        { id: "social_initiatives", label: "Use of local social initiatives and volunteers", description: "Involving the expertise of social initiatives and volunteers to develop and support inclusion." }
      ],
      evidenceGuidance: [
        "How resources support communication, accessibility and digital learning.",
        "How budgets have been allocated to inclusion in the last school year.",
        "How investment has been made in staff training."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Reactive)",
          system: "Reactive allocating of budgets and staff to problems when they arise.",
          financials: "No specific budget is allocated for inclusion; costs are hidden, begrudged, or taken from other budgets.",
          personnel: "One person (SENCO) is the sole manager of all resources. There are no other support staff.",
          tech: "Technology for support needs is inherited or passed down from other departments.",
          livedExperience: "Staff feel they are competing for a limited amount of support."
        },
        2: {
          label: "Level 2 - Emerging (Fragmented)",
          system: "Support is allocated to  specific labelled support needs: gifted, autism, visual impairment etc..",
          financials: "A small allocation of money is given to the support department, separately from the main school curriculum budget.",
          personnel: "If there are support staff, they are assigned to individual students, not classrooms and have little or no training.",
          tech: "Some specialist software exists and is allocated to individuals rather than integrated into the classroom.",
          livedExperience: "Parents are told \"we don't have the funding for that\" as a default response."
        },
        3: {
          label: "Level 3 - Embedded (Consistent)",
          system: "Strategic planning considers equality for all in allocation of support and is assigned to classes or departments rather than individuals.",
          financials: "Inclusion is a core pillar of the 3-year financial plan. Budgeting is proactive and evaluated.",
          personnel: "Support staff are assigned to classrooms rather than students and receive training.",
          tech: "Every teacher has access to a toolkit of technology and skills to implement it.",
          livedExperience: "Predictability. Staff know that if a barrier is identified, the resources to remove it are available."
        },
        4: {
          label: "Level 4 - Advanced (Innovative)",
          system: "Resource-planning is assigned across the school and aimed at reducing barriers for all. Systems are in place to track the impact on students' learning.",
          financials: "The school budget is planned to enhance the learning environment rather than support students with diagnoses or labels.",
          personnel: "Investment is made in the training of all staff in inclusion. The school has a network of experts.",
          tech: "A collaborative strategy for technology use is in place across the school and technology is available to all. Assistive technology is used by some.",
          livedExperience: "Resources for inclusion are integrated in the usual classroom experience. Tech is used proactively rather than for bridging learning gaps."
        },
        5: {
          label: "Level 5 - Sophisticated (Global Leader)",
          system: "Adaptable planned systems for allocating resources, with ownership held by all staff, are in place.",
          financials: "Budgeting is based on improving accessibility for all.The inclusion of minority groups, neurodivergent students, high-performing students, social-emotional needs are embedded.",
          personnel: "The school is recognised as a regional centre of expertise on inclusion.",
          tech: "A collaborative strategy for technology use is used effectively across the whole school.  Assistive technology and AI opportunities are accessible to all and effective.",
          livedExperience: "The school is a global example on how to use its resources and local expertise to develop students and staff’s potential without limits."
        }
      }
    },
    {
      id: "02",
      title: "Station 2: Methods",
      navTitle: "Methods",
      shortDefinition: "The pedagogical engineering of lessons.",
      fullDescription: "Station 2 on Methods refers to the techniques, strategies, and pedagogical approaches used to create inclusive educational organisations. It focuses on the implementation of different teaching methods and approaches to identify needs and support learning in the classroom for all and is the 'how' of implementing inclusion.",
      mainReflectionQuestion: "How well do we use different techniques, strategies, and pedagogical approaches to create an inclusive organisation?",
      assessmentMatrix: [
        { id: "learner_knowledge", label: "Knowledge of how learners learn best", description: "Knowledge and Understanding of the diverse needs of learners, how the brain works, how emotions influence learning, neurodiversity, and the impact of trauma on learning." },
        { id: "neurodiversity_awareness", label: "Awareness of neurodiversity and learning needs", description: "Specific understanding of how neurodivergent students process information and the adjustments required for their success." },
        { id: "differentiated_instruction", label: "Differentiated instruction", description: "The practical ability to tailor teaching methods to meet diverse learning needs, manage the energy of the room, respond to emotional cues, and support complex tasks." },
        { id: "udl", label: "Universal design for learning", description: "Lesson planning that ensures all learners can access and engage with the curriculum from the design stage." },
        { id: "ordinary_available_provision", label: "Ordinary available support provision for all", description: "Support strategies that are available to everyone in the classroom before specific interventions are implemented." },
        { id: "co_teaching", label: "Co-teaching with other educators and paraprofessionals", description: "Collaboration between educators and paraprofessionals to address diverse classroom needs. Push-in support is evident and pull-out support is justified." },
        { id: "push_in_precedence", label: "Push-in support takes precedence over pull-out support", description: "Ensuring that students remain in the core learning environment with their peers as the primary mode of support." },
        { id: "sel_techniques", label: "Social-emotional techniques for well-being", description: "Methods to support students' well-being, including predictability, relational check-ins, adaptations, co-regulation, and partnership with families." },
        { id: "understanding_behaviour", label: "Understanding behaviour challenges in classroom", description: "Beliefs, values, and mindset that shape how teachers interpret behaviours, see student potential, and respond with empathy." },
        { id: "tech_integration", label: "Integration of technology", description: "Using assistive technologies and tools to support participation, access, communication, and wellbeing." }
      ],
      evidenceGuidance: [
        "The availability of adapted texts for students with dyslexia or visual impairments.",
        "Visual supports for students with hearing, language or processing difficulties.",
        "How universal design of lessons is part of the teachers’ planning process.",
        "Ways co-teaching is implemented in the school.",
        "How support is changing from pull-out to push-in.",
        "How technology is used to enable children’s access to the curriculum."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Reactive)",
          system: "Everyone receives the same lesson and teaching.",
          pedagogy: "Lecturing to the whole class is the primary mode of teaching. Differentiation is incidental or non-existent.",
          studentRole: "The child is a passive recipient of the lesson.",
          taRole: "Support staff work exclusively with one child and do the thinking for the child.",
          livedExperience: "Students with high support needs sit at the back of the room. They are disconnected from the teacher and the curriculum."
        },
        2: {
          label: "Level 2 - Emerging (Fragmented)",
          system: "Lessons are adapted for individual students after the main planning is done.",
          pedagogy: "Teachers plan for the average ability group and then simplify worksheets for the lower ability students.",
          studentRole: "Students are categorized into ability groups for lesson activities.",
          taRole: "Support staff work exclusively by withdrawing a group of students from the main classroom for all, or part of, a lesson.",
          livedExperience: "A few students receive extra attention  often resulting in them missing out on rich, deep learning opportunities."
        },
        3: {
          label: "Level 3 - Embedded (Consistent)",
          system: "From the outset, lessons are designed with all students in mind.",
          pedagogy: "Lessons are created with various entry points for students. Multi-modal instructions are available: visual/audio/text.",
          studentRole: "Students have choices about how to demonstrate their knowledge:  video/essay/poster.",
          taRole: "Push-in support is evident and pull-out support is justified. Support staff in the classroom circulate around the room to support all students.",
          livedExperience: "No-one feels  different because the lessons are  designed to be accessible for all, with simplified and extension materials and instructions available to all."
        },
        4: {
          label: "Level 4 - Advanced (Innovative)",
          system: "Students are taught to understand and manage their own learning processes. They help to design assessments.",
          pedagogy: "Teachers use digital tools or rapid formative assessment to adjust their teaching methods in real-time. Feedback to students is instant and personalized.",
          studentRole: "Students are encouraged to articulate how they learn best and to give feedback to teachers on lessons.",
          taRole: "Support staff are co-teachers, have specialised training and are part of the lesson planning process.",
          livedExperience: "The classroom is a high-performance environment where support is seen as enhancing performance for all."
        },
        5: {
          label: "Level 5 - Sophisticated (Global Leader)",
          system: "Barriers to learning are removed at the curriculum design stage; the curriculum is co-authored  and student-led to meet each learner's unique potential.",
          pedagogy: "Methods to support all students' well-being are embedded in all classrooms. Materials represent a range of perspectives and cultures.Choice is a key aspect of teaching and learning",
          studentRole: "Students are co-authors of their own learning pathways.",
          taRole: "Adjustments to the environment and the accessibility of technology mean that support staff in the classroom are rarely required",
          livedExperience: "Truly sophisticated, forward-thinking education, where the need for special support is eliminated and all lessons are universally accessible and designed for excellence."
        }
      }
    },
    {
      id: "03",
      title: "Station 3: Society and an Inclusive Culture",
      navTitle: "Society",
      shortDefinition: "The architecture of belonging; how the school fosters empathy and student-led advocacy.",
      fullDescription: "Schools and other educational organisations often reflect the society in which they are situated. However, schools can also be a model for the local community in the way that their culture respects diversity and stimulates belonging for everyone. The culture of the school includes the shared life of the school: how relationships feel, how staff and students support one another, how families are welcomed, and how belonging is built.",
      mainReflectionQuestion: "How strong is your culture of care, connection, and togetherness?",
      assessmentMatrix: [
        { id: "cultural_competence", label: "Celebrations, traditions and rituals reflecting the students' backgrounds", description: "Awareness and respect for diverse cultural backgrounds which may include shared celebrations, traditions and rituals that reflect the students’ home backgrounds." },
        { id: "preferred_languages", label: "Stimulation of preferred (first, home) language", description: "Validation of Preferred Languages: Stimulation of the use of preferred (first, home) languages in school, translanguaging activities, and connections between students who speak the same preferred language." },
        { id: "community_engagement", label: "Involvement of families in school life", description: "Community Engagement: Involvement of families and local communities in fostering inclusion. Includes Parent-Teacher organisations and involvement in the local community." },
        { id: "student_voice_decisions", label: "Students' voice heard in school decisions", description: "Student Voice: Encouraging collaboration and empathy among students. Stimulation of the student voice so that everyone’s ideas can be heard, including a Student Council." },
        { id: "student_feedback", label: "Students give feedback on lessons and on their learning", description: "Students are encouraged to give feedback on lessons and their own learning to foster agency and collaboration." },
        { id: "anti_discrimination", label: "Discrimination and bias are addressed", description: "Anti-Discrimination Practices: Biases and discrimination are addressed. Equity is promoted across the institution." },
        { id: "marginalised_voice", label: "Marginalised groups have opportunities to be heard", description: "Ensuring that students from all backgrounds, especially those traditionally marginalized, have a platform and influence." },
        { id: "student_transitions", label: "Onboarding and exiting processes for students", description: "Processes for welcoming new students and helping them find their place, as well as exiting them in thoughtful and emotionally healthy ways." },
        { id: "staff_transitions", label: "Onboarding and exiting processes for staff", description: "Thoughtful processes for welcoming and exiting staff members to maintain a healthy school community." },
        { id: "staff_wellbeing_stimulated", label: "The well-being of staff is actively stimulated", description: "Staff Well-being: A culture of psychological well-being of staff is a priority. Ensuring staff are valued members of the community." },
        { id: "staff_valuation", label: "All staff feel valued and listened to by school management", description: "Ensuring staff are able to offer suggestions, raise concerns and participate in decision-making." },
        { id: "digital_wellbeing", label: "Digital well-being is embedded in the school culture", description: "Online and Offline Safety: Digital well-being and safeguarding processes are established and maintained." }
      ],
      evidenceGuidance: [
        "Translanguaging in the classroom.",
        "The celebration of cultural festivals in the school, involving the families.",
        "The ways that the students’ voices are heard.",
        "The ways that the students give feedback to teachers about their learning.",
        "How new students are welcomed into the school and become part of the community."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Compliance Culture)",
          system: "A culture of compliance; the school policy on inclusion is evident in documents but is not the lived experience of students, families or staff.",
          values: "Diversity is a topic that is discussed once a year as a project or special event. Other cultures and languages are celebrated on an International Day.",
          studentVoice: "Students have few or no opportunities to be consulted about school life.",
          community: "Parents of children with additional support needs are seen as being difficult. They are expected to speak the school language when on the school grounds.",
          livedExperience: "A segregated mentality exists of “us v them”. Vulnerable students are tolerated but have no real friends in the school. Genders may be treated differently."
        },
        2: {
          label: "Level 2 - Emerging (Awareness Culture)",
          system: "A culture of raising awareness within the school; timetabled moments to raise awareness of different groups within the school.",
          values: "Diversity is taught through posters and Awareness Weeks (e.g., Autism Month). Other languages are evident in classroom displays or in corridors.",
          studentVoice: "A Student Council is in place but has no real power to contribute to change. Well-being checklists are carried out with limited follow-up.",
          community: "Occasional Coffee Mornings are held for specific parent groups.",
          livedExperience: "Inclusion is based on pity. Students behave kindly to those with additional needs but do not see them as equal peers or leaders."
        },
        3: {
          label: "Level 3 - Embedded (Belonging DNA)",
          system: "A culture of belonging is throughout the school and woven into the daily identity of the school, ensuring that every student and parent feels instinctively part of the community.",
          values: "Diversity is a primary asset of the school and celebrated. Students’ home backgrounds are reflected in the school.",
          studentVoice: "\"Inclusion Ambassadors\" lead peer-to-peer training about specific needs and encourage empathy. “Language Ambassadors\" assist with translation in lessons and in social situations.",
          community: "An elected Parent Committee contributes to change within the school. All parents’ languages are welcomed in the school.",
          livedExperience: "Students advocate for each other without being prompted by teachers. Inclusion is the norm."
        },
        4: {
          label: "Level 4 - Advanced (Advocacy Engine)",
          system: "Students are empowered to actively lead the inclusion agenda by auditing their own environment for barriers and campaigning for systemic empathy and social change.",
          values: "Radical Empathy is taught as a core skill. Intentional understanding and sharing the feelings of others as well as taking concrete action for social change.",
          studentVoice: "Students audit the school’s culture and the actual experience of students in the school for the school management. Translanguaging is normal practice.",
          community: "There are onboarding and exit procedures for staff and students. Every person is seen as valuable to the community and encouraged to contribute.",
          livedExperience: "Total psychological safety. Students feel free to be their authentic selves (Neurodivergent, LGBTQ+, etc.) without fear of judgment."
        },
        5: {
          label: "Level 5 - Sophisticated (Global Conscience)",
          system: "The school acts as a model, within the local community and beyond, for social cohesion; radical empathy is embedded and students are prepared to lead inclusive reform on a local, national or global stage.",
          values: "The school demonstrates \"The Architecture of Belonging\" in practice and works actively to shape environments locally, nationally and globally that are inclusive.",
          studentVoice: "Students consult with local or national government on inclusion policy.",
          community: "The school is a hub for social reform in the local community. The school actively shares expertise and collaborates with global partners to define inclusive excellence on a world stage.",
          livedExperience: "A \"Belonging Revolution.\" The school is a masterclass in social cohesion, producing world class empathetic leaders."
        }
      }
    },
{
      id: "04",
      title: "Station 4: Environment",
      navTitle: "Environment",
      shortDefinition: "The design of sensory-smart, flexible, and technologically integrated physical spaces.",
      fullDescription: "The inclusive aspects of the physical setting of the school or college play an important role in how well students and staff feel that the environment is ‘theirs’. This station includes the accessibility, layout, infrastructure, and resources available in the physical space of your organisation.",
      assessmentMatrix: [
        { id: "accessibility", label: "Accessibility throughout the school and grounds", description: "The buildings, facilities, grounds and resources are usable by everyone and may include ramps, elevators, accessible toilets." },
        { id: "adaptive_spaces", label: "Flexible layouts of learning spaces", description: "Flexible layouts that accommodate different needs. This may include work bays, room to stand to work or lie on floor, quiet spaces, flexible organisation of tables and chairs." },
        { id: "adaptive_furniture", label: "Flexible furniture", description: "Flexible furniture for different needs. This may include different sizes of furniture, sloping desktops, standing tables, cushions and dimmable lighting." },
        { id: "signage", label: "Signage and navigation", description: "Inclusive and clear signs which may include braille, pictograms and maps." },
        { id: "safety", label: "Safety measures for people with disabilities", description: "Adjustments to enhance safety for individuals with disabilities, such as handrails, evacuation plans, clutter-free corridors." },
        { id: "inclusive_tech", label: "Inclusive technology", description: "Devices or technological infrastructure supporting access, connection, communication and digital wellbeing (hearing loops, screen readers, translation tools, live subtitling, etc)." },
        { id: "emotional_balance", label: "Emotional balance and regulation", description: "How the environment can be adapted to support emotional regulation. Includes adaptive lighting, quiet areas, movement breaks, predictable routines and sensory tools." }
      ],
      evidenceGuidance: [
        "Flexible learning spaces.",
        "How technology helps make your school and curriculum accessible to all.",
        "How the transitions between lessons are managed.",
        "Ways that students’ sensory needs are met."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1: Beginning (Reactive)",
          system: "The environment is institutional or industrial. Some students cannot access parts of the building or grounds.",
          sensory: "Fluorescent lighting, bells for the end of lessons, hard surfaces, visual clutter.",
          agility: "Desks in rows; furniture is inflexible; no furnishings; all desks and chairs are the same size.",
          tech: "Static desktop computers in a separate lab or trolley for whole class use.",
          livedExperience: "Students with sensory needs are in a state of constant high alert or shutdown."
        },
        2: {
          label: "Level 2: Emerging (Fragmented)",
          system: "The environment has some adjustments for some support needs.",
          sensory: "Some designated quiet zones or sensory rooms, as additional or timetabled provision.",
          agility: "Some beanbags or different chairs available in a few rooms.Furniture arrangements are static.",
          tech: "A few devices are available for named individual children with specific support needs.",
          livedExperience: "Small modifications exist for individuals, but generally the school environment is overwhelming for a significant percentage of the students."
        },
        3: {
          label: "Level 3 - Embedded (Consistent)",
          system: "The environment is sensory-friendly and is physically accessible to all. Signage is inclusive and may include Braille, and pictos.",
          sensory: "Acoustics, lighting, and air quality are managed school-wide for regulation.Use of voice tools, text to speech, voice overs.",
          agility: "Flexible furniture: stand-up desks, wobble stools in every room. Handrails on stairs and in toilets.Furniture is easy to move around. Tables are able to accommodate wheelchairs.",
          tech: "Devices readily available to teachers and students in an integrated flexible way.",
          livedExperience: " The environment helps the students to regulate. It is designed for focus and cognitive ease. All students can move around the building independently."
        },
        4: {
          label: "Level 4 - Advanced (Innovative)",
          system: "The school building actively contributes to learning, provides specific areas for high-energy collaboration and also for deep-focus study to suit diverse learning needs throughout the day.",
          sensory: "Nature is integrated into the building. Soundscapes used to manage energy levels. Hearing loops are integrated. AI visual description tools which aid independence.",
          agility: "Many classrooms are set up to support the lesson planning. Students may choose to work in places other than the classroom",
          tech: "Smart boards, live subtitling and recording. Seamless, wireless integration. 1-to-1 devices configured to the individual.",
          livedExperience: "The building and classrooms adapt to the student, rather than the student having to survive the building."
        },
        5: {
          label: "Level 5 - Sophisticated (Global Leader)",
          system: "The physical environment is scientifically engineered to regulate the human nervous system and optimize cognitive performance, ensuring the school's architecture proactively supports the biological needs of every learner.",
          sensory: "Neuro-responsive environments align with human brain function and support well-being.",
          agility: "Total flexibility of learning spaces that transform based on the lesson's goal.",
          tech: "Innovative integration of tech for all. Independent student access for all to a range of technologies that suits the child.",
          livedExperience: "A world-leading masterclass in architectural empathy. The building \"hugs\" the nervous system, maximizing human potential."
        }
      }
    },
    {
      id: "05",
      title: "Station 5: Policy",
      navTitle: "Policy",
      shortDefinition: "The living frameworks that protect equity, safeguarding, and non-discrimination.",
      fullDescription: "This station focuses on the policies and regulations that govern inclusion and that are in place in your organisation. Policies ensure that everyone is aware of the expectations and responsibilities for inclusion within the organisation. This includes not only educational policies but also classroom rules and workplace regulations which ensure that inclusive practices are implemented and followed.",
      mainReflectionQuestion: "How inclusive are your school's policies?",
      assessmentMatrix: [
        { id: "anti_discrimination_laws", label: "Awareness of national and local legislation related to inclusion", description: "Anti-Discrimination Laws: Awareness of national and local legal frameworks that protect individuals from exclusion and stimulate inclusion." },
        { id: "staff_recruitment", label: "Non-discriminatory recruitment of staff", description: "Recruitment of Staff: Non-discriminatory processes are in place for all levels of hiring." },
        { id: "cross_org_policies", label: "Cross-school policies include aspects of inclusion, belonging and well-being", description: "Cross-organisation Policies: Aspects of inclusion, belonging and well-being are found in policies across the entire organisation." },
        { id: "student_admissions", label: "Non-discriminatory school admissions process", description: "Admission of students: Non-discriminatory processes are in place for student intake." },
        { id: "safeguarding_justice", label: "Safe guarding, anti bullying and restorative justice policies", description: "Safe-guarding, Anti-bullying and Restorative Justice: Integrated policies are in place to protect and restore the community." },
        { id: "staff_wellbeing_policy", label: "Staff well being and support policies", description: "Well-being and Support of staff: Policies are in place and staff are fully aware of these support structures." },
        { id: "assessment_data_cohorts", label: "Assessment data is reviewed for different student cohorts", description: "Assessment data: Data is reviewed regularly and the academic and social development of different student cohorts is monitored." },
        { id: "grievance_procedures", label: "Grievance procedures", description: "Grievances, Discrimination or Exclusion: Clear policies and processes are in place. Staff and parents are aware of these." },
        { id: "policy_monitoring", label: "Policies are monitored and reviewed", description: "Monitoring of Policies: Policies are monitored for effectiveness and there is a tracking system for reviewing these regularly." }
      ],
      evidenceGuidance: [
        "How safeguarding takes place during recruitment, admissions and/or in digital learning.",
        "How a bullying incident was dealt with.",
        "How a policy is put into practice, reviewed and updated."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Static/Protective)",
          system: "Policies are static and protective of the school or organisation. They are rarely evaluated or updated.",
          format: "Long documents stored in cupboards or computer drives and not often read..",
          language: "Legalistic, defensive, and compliance-focused. Class rules focus on negative behaviour.",
          authorship: "Copied from a government template.",
          livedExperience: "Policies are only used when a parent sues or an inspector arrives and not reflected in the daily life of the school."
        },
        2: {
          label: "Level 2 - Emerging (Isolated Policy)",
          system: "Policies are written for each aspect of school life by managers. They are updated according to a schedule.",
          format: "The Inclusion Policy is a separate document, disconnected from the  \"Teaching & Learning Policy”.",
          language: "Policies use labels to define the groups that they apply to and may refer to what the school cannot do rather than what it can do.",
          authorship: "Policies are written by department managers. The inclusion policy is written by the SENCO alone.",
          livedExperience: "Staff know the policies exist but do not use them as helpful documents. Class rules are displayed but not referred to."
        },
        3: {
          label: "Level 3 - Embedded (Living Framework)",
          system: "Policies are written by the whole school community and act as a daily \"how-to\" guide for removing systemic barriers in real-time. Inclusion is embedded in all policies.",
          format: "Policies are easily available e.g. in digital form, visually, as a presentation, in different languages.",
          language: "Focused on removing systemic barriers and on the well-being of all staff and students.",
          authorship: "Written with input from all staff and students.",
          livedExperience: "Policies are the shared language of the school. They are used daily in the design learning and in resolving conflicts. They contribute to the well-being of all staff and students."
        },
        4: {
          label: "Level 4 - Advanced (Equity-First)",
          system: "Policies are in place that hold the leadership accountable for protecting the human rights of all staff and students: in recruitment, admissions, safe-guarding, well-being and grievances.",
          format: "Inclusive thinking is embedded into every school policy and contract.",
          language: "Focused on human rights and empowering students to participate fully in school life.",
          authorship: "The school‘s policies are used as templates by other schools, both locally and nationally.",
          livedExperience: "Policies are used to hold the Board and Principal accountable. They protect the most vulnerable as a non-negotiable right."
        },
        5: {
          label: "Level 5 - Sophisticated (Global Ethical Standard)",
          system: "The school’s policies serve as a moral operating system for the whole school and students are prepared for the future of global education.",
          format: "Policies evolve and are re-written in response to data, experiences and input from staff and students.",
          language: "Defining the future of global educational law.",
          authorship: "The school‘s policies are used as templates by other schools, both nationally and internationally.",
          livedExperience: "There is no need for an inclusion policy as inclusion is perfectly mirrored in every interaction and decision. Everyone is treated without discrimination and equity."
        }
      }
    },
    {
      id: "06",
      title: "Station 6: Leadership",
      navTitle: "Leadership",
      shortDefinition: "The strategic vision where inclusion drives high-performance and ethical culture.",
      fullDescription: "Leadership refers to the role of decision-makers and leaders who are responsible for setting the vision and direction of the organisation, shaping the culture of the organisation and in driving and modeling inclusive practices. This station focuses on leaders who model inclusive values, support staff wellbeing, and ensure inclusion is part of the organisation's strategic planning.",
      mainReflectionQuestion: "School leadership actively builds inclusion?",
      assessmentMatrix: [
        { id: "mission_vision", label: "Clear and inclusive mission and vision", description: "Vision and Mission: School leaders establish a clear, inclusive mission and vision for the organisation and communicate expectations about inclusion effectively." },
        { id: "policy_review", label: "Policies are monitored and reviewed", description: "Ensuring that the strategic frameworks of the school are constantly evaluated for their impact on inclusion." },
        { id: "improvement_planning", label: "Inclusion is part of school improvement planning", description: "School improvement: Inclusion shapes school improvement planning and is discussed regularly at leadership meetings." },
        { id: "role_modeling", label: "Leaders as role models of inclusion", description: "Role Modeling: Leaders model and protect inclusive behaviours in every interaction." },
        { id: "stakeholder_collaboration", label: "Leaders collaborate with other stake holders in decision-making", description: "Stakeholder Collaboration: Leaders engage and collaborate with staff, families, and communities in decision-making." },
        { id: "crisis_management", label: "Leading inclusively in challenging situations", description: "Crisis Management: Leaders lead inclusively during challenging situations (e.g., conflicts, emergencies). The response supports an inclusive philosophy." },
        { id: "disseminated_responsibility", label: "All teachers are stimulated to be responsible for inclusion", description: "Leaders stimulate and support all teachers in taking responsibility, not just the Learning Support team or a small group of staff." }
      ],
      evidenceGuidance: [
        "How inclusion features in leadership meetings.",
        "How leaders model inclusive practice.",
        "How the responsibility of inclusion is disseminated and shared amongst all staff."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Delegation/Isolation)",
          system: "Delegation and isolation.",
          vision: "Inclusion is delegated to the SENCO or a nominated lead teacher. It is seen as an extra add-on to the school’s educational offer.",
          accountability: "The Principal holds the SENCO or nominated lead teachers for inclusion and well-being accountable for inclusion and is not accountable him/herself.",
          board: "Inclusion is not an item on the Board’s agenda.",
          livedExperience: "School leaders are too busy for inclusion. It is a niche department at the edge of the school's identity."
        },
        2: {
          label: "Level 2 - Emerging (Supportive/Passive)",
          system: "Supportive and passive.",
          vision: "Inclusion is considered to be important but school results are more important.",
          accountability: "The SENCO is a middle manager  and reports to a Deputy Principal.",
          board: "The Board receives statistics about groups within the school but not about inclusion as a culture.",
          livedExperience: "School leaders say the right things in speeches but do not model inclusive pedagogical leadership or implement change."
        },
        3: {
          label: "Level 3 - Embedded (Strategic Integration)",
          system: "Strategic integration.",
          vision: "Inclusion is a core element in the school's 5-year plan and discussed regularly in staff meetings.",
          accountability: "The SENCO is a senior manager and  reports to the Principal. Inclusion data is analyzed alongside academic data.",
          board: "The lead teacher for inclusion (SENCO) is invited to participate in Board meetings.",
          livedExperience: "Leadership of inclusion is visible. The Principal knows the names and needs of the most vulnerable and the most gifted equally."
        },
        4: {
          label: "Level 4 - Advanced (Distributed Leadership)",
          system: "Distributed leadership.",
          vision: " Inclusion is understood to be the driver of high performance in the school and is the shared responsibility of all staff.",
          accountability: "The school leadership supports every teacher in carrying out their responsibility for fostering inclusive behaviours in the school.",
          board: "Inclusion is seen as the school's competitive advantage. A Board member has responsibility for monitoring and stimulating inclusion in the school.",
          livedExperience: "The school is led with sophisticated empathy. The Principal leads inclusively in complex and sensitive situations."
        },
        5: {
          label: "Level 5 - Sophisticated (Visionary Global Influence)",
          system: "Visionary Global Influence.",
          vision: "The school’s culture inherently drives and models inclusive practices and inclusion is an integral part of the organisation’s strategic planning.",
          accountability: "Radical transparency. The school shares its data on student achievement growth internationally and seeks global feedback.",
          board: "The school advises the IFIP and local and national governments, G20 or UNESCO on education.",
          livedExperience: "The Principal is a global leader on inclusive education. There is total synergy between elite performance and radical inclusion."
        }
      }
    },
    {
      id: "07",
      title: "Station 7: Mindset",
      navTitle: "Mindset",
      shortDefinition: "The collective belief system regarding human potential and unconscious bias.",
      fullDescription: "The station Mindset refers to the attitudes, beliefs, and values held by individuals, both students and staff, and the communities of which the educational organisation is part. It is about changing perceptions to embrace diversity, inclusion, and equity. This station emphasizes the importance of fostering an inclusive mindset at all levels.",
      mainReflectionQuestion: "The school has a growth-oriented mindset towards inclusion?",
      assessmentMatrix: [
        { id: "bias_awareness", label: "Identifying and addressing unconscious biases", description: "Bias Awareness: Identifying and addressing unconscious biases to ensure they do not limit student or staff potential." },
        { id: "growth_mindset_all", label: "Growth mindset and belief that all students can succeed", description: "Growth Mindset: Fostering a belief in the ability to learn and adapt. The unwavering belief that all students can succeed." },
        { id: "empathy_development", label: "Empathy Development: Encouraging understanding of others' perspectives", description: "Empathy Development: Encouraging understanding of others' perspectives through patience and empathy." },
        { id: "emotional_ecology", label: "The importance of emotional safety, steadiness, and predictability", description: "Emotional Ecology: The emotional quality of the school day. Recognising the importance of safety, calmness, sensory awareness, predictability, and nervous system readiness." },
        { id: "resilience_openness", label: "Resilience and openness to change", description: "Resilience and Openness: Building the ability to embrace change and diversity and a willingness to adjust practice." },
        { id: "continuous_reflection", label: "Continuous reflection", description: "Continuous Reflection: Evidence of ongoing self-assessment of individuals, groups and the organisation, leading to the improvement of inclusive attitudes." }
      ],
      evidenceGuidance: [
        "The belief that all students can succeed and how this has been seen in practice.",
        "The way that a change has been made in the last 12 months and its effect on student learning.",
        "How the SENCo (Learning Support Co-ordinator) helps teachers to be responsible for inclusion in their lessons.",
        "How a student from a marginalised or disadvantaged group demonstrates that they truly belong to the school community."
      ],
      diagnosticGrid: {
        1: {
          label: "Level 1 - Beginning (Fixed/Medical Model)",
          system: "A fixed or medical mindset.",
          belief: "Certain students are the responsibility of the SENCO.",
          bias: "Discrimination goes unchallenged. Diversity is tokenized and sectarian.",
          language: " ‘Someone else needs to take this child’. ‘A problem child’.  ‘Low ability.’ ‘He belongs in a different school.’ ",
          livedExperience: "Staff feel like inclusion is too difficult and they are waiting for the child to leave."
        },
        2: {
          label: "Level 2 - Emerging (Sympathetic/Burdened)",
          system: "A sympathetic or burdened mindset.",
          belief: "Specialist training is required to work with children with additional needs.",
          bias: "Staff have lowered expectations for some, based on diagnosis or standardised testing.",
          language: "‘He does not have the capability.’ ‘He is doing well despite his disability.’ ",
          livedExperience: "A culture of pity. Staff are frustrated and feel that inclusion slows down the progress of \"normal\" students."
        },
        3: {
          label: "Level 3 - Embedded (Professional/Ownership)",
          system: "A professional or ownership mindset.",
          belief: "All teachers are experts and can work to remove barriers to learning.",
          bias: "Unconscious bias training is mandatory and transformative.",
          language: "‘Potential.’ ‘Can we share strategies?’ ‘Looking for solutions.’ ",
          livedExperience: "Staff room talk is about problem-solving. Inclusion is seen as the mark of a \"Master Teacher.\" "
        },
        4: {
          label: "Level 4 - Advanced (Growth/Innovation)",
          system: "A growth or innovation mindset.",
          belief: "Every student is a source of data to improve my teaching: include one, benefit all.",
          bias: "Radical curiosity about difference and diversity as a strength.",
          language: "‘Cognitive Diversity.’ ‘How can I learn from you?’ ‘What do you need?’",
          livedExperience: "High-performance mindset for all. Staff are scientific practitioners who love the challenge of complex learners."
        },
        5: {
          label: "Level 5 - Sophisticated (Oxygen/Transcendence)",
          system: "\"Transcendence.\" Inclusion ceases to be a separate initiative and becomes the school's invisible, essential atmosphere, where a radical belief in infinite human potential is the natural state for every teacher and student.",
          belief: "\"There are no 'special' needs, only 'human' needs.\"",
          bias: "Total awareness and eradication of systemic prejudice.",
          language: "‘How can I make this possible?’ Language of Infinite Human Potential.",
          livedExperience: "The school's \"Soul.\" A sophisticated, modern, forward-thinking environment where inclusion is the invisible oxygen everyone breathes."
        }
      }
    }
  ],

  accreditationForm: {
    title: "Application Form: IFIP Accreditation",
    intro: "The International Standard for Inclusive Practice.",

    // Integrated UI Interface Block
    reg_ui: {
      btn_next: "Next Step",
      btn_back: "Back",
      btn_submit: "Submit Application",
      btn_save: "Save",
      btn_cancel: "Cancel",
      status_submitting: "Processing Submission...",
      success_title: "Application Received",
      select_path_title: "Select Your Accreditation Stage",
      lang_label: "Language Selector:",
      step_indicator: "Step",
      of: "of",
      snapshot_header: "Institutional Snapshot",
      snapshot_intro: "IFIP has already extracted this information from your application form.",
      snapshot_no_data: "No data added yet",
      snapshot_label_stage: "Accreditation Stage Requested",
      snapshot_label_contact: "Lead Contact",
      snapshot_label_students: "Students on Roll",
      snapshot_label_needs: "Student Need Profile",
      snapshot_label_total_staff: "How many staff are employed at the school?",
      snapshot_label_specialists: "Specialist Staff",
      snapshot_label_training: "Recent Training",
      snapshot_headcount_suffix: "Total specialist staff",
      auditInstructions: "For each station, please assess your organisation against the five levels and provide a written commentary. Support your assessment by uploading to the Evidence Vault. Further guidance notes may be found in the side panel, updated for each station selected.The system will automatically save your progress.",
      header_evidenceVault: "Evidence Vault",
      title: "Accreditation Application Progress",
      intro: "Please complete the preliminary diagnostic to initiate your institutional profile.",
      expand_box: "The text area will expand as you type",
      success_msg: "Your institutional data has been logged securely into the IFIP database. A member of the Accreditation Team will review your submission. Upon approval, your unique access link will be dispatched to your registered email address.",
      success_sef: "Thank you for submitting your Self-Evaluation. Your submission has been received and will now be reviewed by our team.",
      success_quest: "Thank you for contributing to the IFIP's Global Research."
    
    },

    stages: {
      foundation: {
        title: "1. IFIP Foundation Inclusive School",
        desc: "Entry-level recognition: Focus on commitment & basic implementation. (Online review)"
      },
      certified: {
        title: "2. IFIP Certified Inclusive School",
        desc: "Mid-level validation: Demonstrates structured practices and measurable inclusion. (School Visit)"
      },
      accredited: {
        title: "3. IFIP Accredited Inclusive School",
        desc: "Highest recognition: Meets global benchmarks and sustained excellence. (School Visit)"
      },
      notSure: {
        title: "Not sure yet",
        desc: "A member of the IFIP will contact you to discuss your needs and stage of readiness."
      }
    },

    sections: [
      {
        id: "identity",
        label: "Organisation Identity",
        questions: {
          officialName: {
            label: "Official name of the Organisation",
            type: "text"
          },
          officialAddress: {
            label: "School/organisation address",
            type: "textarea"
          },
          officialAddressCountry: {
            label: "School/organisation country",
            type: "text"
          },
          q2: {
            label: "Website",
            type: "url"
          },
          orgLead: {
            label: "Name of lead contact person",
            type: "text"
          },
          q3: {
            label: "Email address of lead contact person",
            type: "text"
          },
          q4: {
            label: "Type of school (National, Private, International, etc.)",
            type: "text",
            placeholder: "Please also include the age range of students taught"
          },
          q5: {
            label: "Main language of instruction",
            type: "text"
          },
          q6: {
            label: "Curriculum followed",
            type: "text"
          }
        }
      },
      {
        id: "demographics",
        label: "Student Demographics",
        questions: {
          q7: {
            label: "Number of students on roll",
            type: "number"
          },
          q8: {
            label: "Number of different nationalities among the pupils",
            type: "number"
          },
          q9: {
            label: "Top 5 most spoken languages by students",
            type: "text",
            placeholder: "Separate with commas"
          },
          q10: {
            label: "Inclusion Matrix: Student Need Profile",
            description: "Approximate percentage of your student body in each category:",
            type: "percentageGrid", // New type for structured data
            categories: ["Neurodiversity", "Physical/Sensory Differences", "Social, Emotional or Mental Health Concerns", "Moderate/Severe Learning Difficulties", "Other"],
            descriptions: {
              'Neurodiversity': 'With or without formal diagnosis',
              'Social, Emotional or Mental Health Concerns': 'Including behavior concerns'}
          },
          q11: {
            label: "Does your school have a Student Council?",
            type: "boolean"
          }
        }
      },
      {
        id: "exclusions",
        label: "School Exclusions & Suspensions",
        questions: {
          schoolExclusions: {
            label: "Disciplinary exclusions (instances)",
            description: "Please record the total number of cases/instances for each category, rather than the number of individual pupils affected.",
            type: "exclusionsGrid",
            columns: [
              {
                id: "currentYear",
                label: "Current Academic Year (From the start of the current year to date)"
              },
              {
                id: "previousYear",
                label: "Previous Academic Year (Full year)"
              }
            ],
            rows: [
              {
                id: "temporary",
                label: "Temporary Exclusions (Suspensions)",
                guidance:
                  "Enter the total number of instances where a pupil was officially removed from the school for a set period of time for disciplinary reasons. Do not count the number of unique pupils; if one pupil was suspended three times, this should be counted as 3 instances."
              },
              {
                id: "permanent",
                label: "Permanent Exclusions (Expulsions)",
                guidance:
                  "Enter the total number of instances where a pupil was permanently removed from the school roll for disciplinary reasons."
              }
            ]
          }
        }
      },
      {
        id: "staffing",
        label: "Staff & Training",
        questions: {
          q12: {
            label: "How many staff are employed at the school?",
            type: "number"
          },
          q13: {
            label: "Specialist Support Presence",
            description: "Total number of specialist staff:",
            type: "specialistCount", // New type
            roles: ["Inclusion Manager", "Psychologist", "Speech/Language", "Counsellor", "Learning Support"]
          },
          q14: {
            label: "Staff longevity (Approximate average length of service)",
            type: "text",
            placeholder: "e.g. 2 years"
          },
          q15: {
            label: "Recent Inclusion Training (Last 3 Years)",
            description: "Scope of professional development:",
            type: "trainingChecklist", // New type
            options: ["Whole School Training", "Leadership Only", "Specialists Only", "Parent/Community Training"]
          }
        }
      },
      {
        id: "motivation",
        label: "Motivation & Goals",
        questions: {
          q16: {
            label: "What does 'inclusion' mean in your organisation?",
            type: "textarea"
          },
          q17: {
            label: "Why are you requesting IFIP Accreditation?",
            type: "textarea"
          },
          q18: {
            label: "What do you hope IFIP Accreditation will bring in the future?",
            type: "textarea"
          },
          q19: {
            label: "Can the accreditation be done in English?",
            type: "boolean"
          }
        }
      },
      {
        id: "final",
        label: "Final Submission",
        questions: {
          q20: {
            label: "Name and role of person submitting this form",
            type: "text"
          },
          q21: {
            label: "Institutional Authorization",
            description: "I confirm that I have the authority to submit this application on behalf of the named organisation.",
            type: "checkbox" // Render as a required checkbox
          },
          q22: {
            label: "Accuracy & Truthfulness",
            description: "I declare that the information provided in this preliminary diagnostic is accurate and true to the best of my knowledge.",
            type: "checkbox" // Render as a required checkbox
          },
          q23: {
            label: "Data Processing Agreement",
            description: "I agree to IFIP’s data handling policy, acknowledging that this information will be used for accreditation assessment and institutional profiling.",
            type: "checkbox" // Render as a required checkbox
          },
          q24: {
            label: "Date of submission",
            type: "date"
          }
        } // Closes 'questions'
      } // Closes the 'final' section object
    ], // Closes the 'sections' array
  } // Closes the 'accreditationForm' object
}; // Closes the 'en' export object